// Imports
import React, { Fragment } from 'react';
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import FsmMainView from "Modules/fsm/views/main"
import { HasPermission } from "Core/security";


// router 
const RouterFsm = (props) => {
	const user = useSelector(state => state.securityRedux.user)
	return (
		<Routes>
			{
				// TODO submodule-approved
				HasPermission(user, "fsm", [59]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/fsm/main" />}></Route>
					<Route path='main' element={<FsmMainView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};

export default RouterFsm